// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2Ckqb","icon":"style_icon__2XS2D"};